import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCreateFormTemplateMutation, useDuplicateFormTemplateMutation } from '../../../../hooks/mutations/useFormTemplateMutation';
import { useFormTypesQuery } from '../../../../hooks/queries/useFormTypesQuery';
import CustomTextInput from '../../../CustomTextInput';
import DropDown, { OptionType } from '../../../DropDown';
import ModalBody, { ModalProps } from '../../ModalBody';
import { useNavigate } from 'react-router-dom';
import { capitalizeFirstLetter } from '../../../../utils/capitalize';
import { useCreateFormAccessMutation } from '../../../../hooks/mutations/useFormAccessMutation';
import { useLatestFormTemplatesQuery } from '../../../../hooks/queries/useFormTemplatesQuery';
import { FormTemplate } from '../../../../services/apiSLTP/qhse/forms/formTemplates';

interface AddGroupFormAccessModalProps extends ModalProps {
    refetch?: () => void;
    userId: string;
    userName: string;
    forms: FormTemplate[];
}

const AddGroupFormAccessModal: React.FC<AddGroupFormAccessModalProps> = ({ open, handleClose, refetch = () => {}, userId, userName, forms }) => {
    const { t } = useTranslation();

    const [selectedForm, setSelectedForm] = useState<OptionType | null>(null);

    const { mutate: createFormAccess } = useCreateFormAccessMutation({
        onSuccess: () => {
            refetch();
        },
    });

    return (
        <ModalBody
            closeText={t('cancel')}
            okText={t('createCopy')}
            title={t('form')}
            subTitle={t('createCopy')}
            description={userName}
            open={open}
            handleClose={handleClose}
            handleOk={() => {
                createFormAccess({ groupId: selectedForm?.value || '', userId });
            }}
            disabledOk={!selectedForm}
        >
            <DropDown
                items={forms.filter((form) => !form.isPublic).map((form) => ({ label: form.title, value: form.groupId }))}
                inputLabel={capitalizeFirstLetter(t('form'))}
                selectedItem={selectedForm}
                handleChange={(e, value) => setSelectedForm(value)}
                required
            />
        </ModalBody>
    );
};

export default AddGroupFormAccessModal;
